const initialState = {}

export default function data(state = initialState) {
  return state
}



// WEBPACK FOOTER //
// ./src/store/reducers/data.js